import React, { Component } from 'react';
import authService from '../api-authorization/AuthorizeService'
import { Helmet } from "react-helmet";
import { OnboardingSteps } from './OnboardingSteps';

export class Rent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companies: [],
      services: [],
      resources: []
    };
  }

  componentDidMount() {
    this._subscription = authService.subscribe(() => this.populateState());
    this.populateState();
  }

  componentWillUnmount() {
    authService.unsubscribe(this._subscription);
  }

  async populateState() {
    const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
    this.setState(prevState => ({
      ...prevState,
      isAuthenticated,
      userName: user && user.name,
      activeFaq: 0,
    }));
    if (isAuthenticated) {
      this.populateCompaniesData();
    }
  }

  async populateCompaniesData() {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/admin`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, companies: data}));
    if (data.length > 0) {
      const response1 = await fetch(`{{mainApiUrl}}api/companies/${data[0].id}/services`, {
        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
      });
      const data1 = await response1.json();
      this.setState(prevState => ({...prevState, services: data1}));

      const response2 = await fetch(`{{mainApiUrl}}api/companies/${data[0].id}/resources`, {
        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
      });
      const data2 = await response2.json();
      this.setState(prevState => ({...prevState, resources: data2.filter(d => d.assigned)}));
    }
  }

  toggleFaq = (index) => {
    this.setState(prev => ({ activeFaq: prev.activeFaq === index ? -1 : index }));
  };

  render() {
    const faqs = [
      { q: "❓ Это действительно бесплатно?", a: "Да. Никакой абонентской платы, процентов с броней. Оплата только за SMS и эквайринг (если подключите)." },
      { q: "❓ Как клиент выбирает конкретную единицу?", a: "Он видит фотографии, состояние и календарь занятости каждого экземпляра и выбирает именно тот, который хочет." },
      { q: "❓ Можно ли добавить доставку?", a: "Да. При оформлении клиент видит опцию доставки с фиксированной ценой, которую вы устанавливаете." },
      { q: "❓ Как отслеживать возврат?", a: "Система напоминает клиенту о возврате, вы видите статус. Можно отметить возврат вручную, хранится история." },
      { q: "❓ Нужно ли устанавливать приложение?", a: "Нет, достаточно браузера. Но есть и нативные приложения для iOS и Android." }
    ];

    return (
      <div>
        <Helmet>
          <title>Система учёта и бронирования аренды | Прокат оборудования — Planna</title>
          <meta name="description" content="Управляйте арендой инструментов, техники или одежды. Клиенты видят фото и выбирают конкретные единицы. Контроль возврата, история, напоминания. Бесплатно." />
          <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css"/>
          <link href="https://fonts.googleapis.com/css2?family=Inter:opsz,wght@14..32,300;14..32,400;14..32,500;14..32,600;14..32,700&family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap" rel="stylesheet"/>
          <script src="{{mainApiUrl}}landing.js"></script>
        </Helmet>
        {/* Hero */}
        <section className="hero">
          <div className="container fade-up">
            <div className="hero-badge">🔧 Для проката оборудования, инструментов, техники, одежды | Бесплатно навсегда</div>
            <h1>Управляйте арендой <span className="highlight">визуально и без тетрадки</span></h1>
            <p className="hero-description">Клиенты сами выбирают конкретную единицу по фото, добавляют доставку. Вы контролируете возвраты, занятость и доход. Всё бесплатно.</p>
            <div className="hero-buttons" style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
              {!this.state.isAuthenticated ? <a href="/authentication/register" className="btn-filled">Зарегистрироваться <i className="fas fa-arrow-right"></i></a> : <></>}
              <a href="/configcompany" className={this.state.isAuthenticated ? "btn-filled" : "btn-outline"}>Подключить прокат бесплатно <i className="fas fa-play"></i></a>
            </div>
          </div>
        </section>

        {/* Преимущества */}
        <section>
          <div className="container">
            <div className="fade-up" style={{ textAlign: 'center' }}>
              <h2 className="section-title">Всё для автоматизации проката</h2>
              <p className="section-subtitle">Принимайте заказы онлайн, управляйте парком и увеличивайте доход</p>
            </div>
            <div className="grid-3 fade-up">
              <div className="benefit-card"><i className="fas fa-camera benefit-icon"></i><h3>Выбор по фото</h3><p>Клиент видит реальные фото, состояние и комплектацию каждой единицы.</p></div>
              <div className="benefit-card"><i className="fas fa-truck benefit-icon"></i><h3>Доставка с фиксированной ценой</h3><p>Клиент добавляет доставку одним кликом, цена известна заранее.</p></div>
              <div className="benefit-card"><i className="fas fa-calendar-week benefit-icon"></i><h3>Календарь занятости</h3><p>Каждая единица имеет свой календарь – свободна, в аренде, на ремонте.</p></div>
              <div className="benefit-card"><i className="fas fa-clock benefit-icon"></i><h3>Напоминания о возврате</h3><p>Клиент получает уведомление за день до окончания аренды.</p></div>
              <div className="benefit-card"><i className="fas fa-chart-line benefit-icon"></i><h3>Аналитика дохода</h3><p>Самые популярные позиции, доход по каждой единице.</p></div>
              <div className="benefit-card"><i className="fas fa-qrcode benefit-icon"></i><h3>QR-код для заказа</h3><p>Клиент сканирует и сразу переходит к выбору.</p></div>
            </div>
          </div>
        </section>

        {/* Скриншоты (замените src) */}
        <section style={{ background: '#F9FAFB' }}>
          <div className="container">
            <div className="fade-up" style={{ textAlign: 'center' }}>
              <h2 className="section-title">Как это работает</h2>
              <p className="section-subtitle">Просто, наглядно, удобно</p>
            </div>
            <div className="grid-2 fade-up" style={{ gap: '2.5rem' }}>
              <div className="screenshot-placeholder"><img src="https://placehold.co/600x400/EEF2FF/3B82F6?text=Выбор+по+фото" alt="Выбор по фото" /><div className="mockup-label">🛠️ Фото каждой единицы</div></div>
              <div className="screenshot-placeholder"><img src="https://placehold.co/600x400/EEF2FF/3B82F6?text=Календарь+занятости" alt="Календарь" /><div className="mockup-label">📅 Занятость наглядно</div></div>
              <div className="screenshot-placeholder"><img src="https://placehold.co/600x400/EEF2FF/3B82F6?text=Доставка" alt="Доставка" /><div className="mockup-label">🚚 Доставка с фиксированной ценой</div></div>
              <div className="screenshot-placeholder"><img src="https://placehold.co/600x400/EEF2FF/3B82F6?text=Напоминание+о+возврате" alt="Напоминание" /><div className="mockup-label">🔔 Напоминание о возврате</div></div>
            </div>
          </div>
        </section>

        {/* Умные функции */}
        <section>
          <div className="container">
            {/* Выбор по фото */}
            <div className="smart-block fade-up" style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '2rem', marginTop: 0 }}>
              <div style={{ flex: 1 }}>
                <i className="fas fa-images" style={{ fontSize: '2.5rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                <h3 style={{ fontSize: '1.8rem', fontWeight: '700' }}>Выбор конкретной единицы по фото</h3>
                <p style={{ margin: '1rem 0', color: '#374151' }}>Каждая единица оборудования, инструмента или вещи имеет свои фото, характеристики, состояние. Клиент видит, что берёт, и не получает «кота в мешке».</p>
                <ul style={{ listStyle: 'none' }}><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Реальные фото каждого экземпляра</li><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Указание состояния и комплектации</li></ul>
              </div>
              <div style={{ flex: 1 }}><div className="screenshot-placeholder"><img src="https://placehold.co/500x300/F9FAFB/32bea6?text=Выбор+по+фото" alt="Выбор по фото" /><div className="mockup-label">🛠️ Вот этот перфоратор – свободен</div></div></div>
            </div>

            {/* Доставка */}
            <div className="smart-block fade-up" style={{ background: '#FFFFFF', border: '1px solid rgba(50,190,166,0.3)', marginTop: '2rem' }}>
              <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '2rem' }}>
                <div style={{ flex: '1.2' }}>
                  <i className="fas fa-truck" style={{ fontSize: '2.5rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                  <h3 style={{ fontSize: '1.8rem', fontWeight: '700' }}>Доставка с фиксированной ценой</h3>
                  <p style={{ margin: '1rem 0', color: '#374151' }}>Клиент добавляет доставку при бронировании, вы сами указываете стоимость. Цена известна заранее, можно предложить самовывоз или доставку.</p>
                  <ul style={{ listStyle: 'none' }}><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Фиксированная цена доставки</li><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Выбор: самовывоз или доставка</li></ul>
                </div>
                <div style={{ flex: 0.9 }}><div className="screenshot-placeholder"><img src="https://placehold.co/450x280/F9FAFB/32bea6?text=Доставка" alt="Доставка" /><div className="mockup-label">🚚 Добавьте доставку одним кликом</div></div></div>
              </div>
            </div>

            {/* Контроль возврата */}
            <div className="smart-block fade-up" style={{ background: '#FFFFFF', border: '1px solid rgba(50,190,166,0.3)', marginTop: '2rem' }}>
              <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '2rem', flexDirection: 'row-reverse' }}>
                <div style={{ flex: '1.2' }}>
                  <i className="fas fa-hand-peace" style={{ fontSize: '2.5rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                  <h3 style={{ fontSize: '1.8rem', fontWeight: '700' }}>Контроль возврата и напоминания</h3>
                  <p style={{ margin: '1rem 0', color: '#374151' }}>Система напоминает клиенту о возврате за день до окончания аренды. Вы получаете уведомление о просрочке. Ведите историю каждой единицы.</p>
                  <ul style={{ listStyle: 'none' }}><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Напоминания клиентам</li><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Оповещения о просрочке для вас</li></ul>
                </div>
                <div style={{ flex: 0.9 }}><div className="screenshot-placeholder"><img src="https://placehold.co/450x280/F9FAFB/32bea6?text=Возврат" alt="Возврат" /><div className="mockup-label">📦 Отметьте возврат – история сохранится</div></div></div>
              </div>
            </div>

            {/* Календарь занятости */}
            <div className="smart-block fade-up" style={{ background: 'linear-gradient(110deg, rgba(50,190,166,0.05) 0%, #FFFFFF 100%)', marginTop: '2rem' }}>
              <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '2rem' }}>
                <div style={{ flex: 1 }}><div className="screenshot-placeholder"><img src="https://placehold.co/450x280/F9FAFB/32bea6?text=Календарь+занятости" alt="Календарь занятости" /><div className="mockup-label">📅 Календарь для каждой единицы</div></div></div>
                <div style={{ flex: '1.2' }}>
                  <i className="fas fa-calendar-alt" style={{ fontSize: '2.5rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                  <h3 style={{ fontSize: '1.8rem', fontWeight: '700' }}>Календарь занятости каждой единицы</h3>
                  <p style={{ margin: '1rem 0', color: '#374151' }}>Вы видите загрузку каждого экземпляра: свободен, в аренде, на ремонте. Клиент выбирает свободные даты. Никаких двойных бронирований.</p>
                  <ul style={{ listStyle: 'none' }}><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Цветовая индикация статуса</li><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Клиент выбирает только свободную технику</li></ul>
                </div>
              </div>
            </div>

            {/* Два календаря */}
            <div className="smart-block fade-up" style={{ background: 'linear-gradient(110deg, rgba(50,190,166,0.05) 0%, #FFFFFF 100%)', marginTop: '2rem' }}>
              <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '2rem' }}>
                <div style={{ flex: '1.2' }}>
                  <i className="fas fa-eye" style={{ fontSize: '2.5rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                  <h3 style={{ fontSize: '1.8rem', fontWeight: '700' }}>Два календаря при бронировании</h3>
                  <p style={{ margin: '1rem 0', color: '#374151' }}>Клиент видит свои личные события (Google/Apple) и свободные слоты выбранной единицы. Выбирает только время, которое подходит обоим. <strong>Никакой записи в его календарь</strong> – только чтение.</p>
                  <ul style={{ listStyle: 'none' }}><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Без конфликтов с личными делами</li><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Удобный выбор времени</li></ul>
                </div>
                <div style={{ flex: 1 }}><div className="screenshot-placeholder"><img src="https://placehold.co/450x280/F9FAFB/32bea6?text=Два+календаря" alt="Два календаря" /><div className="mockup-label">📅 Ваш календарь и календарь сервиса</div></div></div>
              </div>
            </div>
          </div>
        </section>

        {/* Типы аренды */}
        <section style={{ background: '#FEF9F0' }}>
          <div className="container fade-up" style={{ textAlign: 'center' }}>
            <h2 className="section-title">Подходит для любых видов проката</h2>
            <div className="stats-grid" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '1.5rem', marginTop: '2rem' }}>
              <div className="benefit-card" style={{ background: 'white', textAlign: 'center', minWidth: '160px' }}><i className="fas fa-tools"></i><h3>Инструмент</h3><p>Перфораторы, дрели, бензопилы</p></div>
              <div className="benefit-card" style={{ background: 'white', textAlign: 'center', minWidth: '160px' }}><i className="fas fa-car"></i><h3>Спецтехника</h3><p>Экскаваторы, подъёмники</p></div>
              <div className="benefit-card" style={{ background: 'white', textAlign: 'center', minWidth: '160px' }}><i className="fas fa-camera"></i><h3>Фото/видео</h3><p>Камеры, объективы, штативы</p></div>
              <div className="benefit-card" style={{ background: 'white', textAlign: 'center', minWidth: '160px' }}><i className="fas fa-tshirt"></i><h3>Одежда</h3><p>Платья, костюмы, сумки</p></div>
            </div>
          </div>
        </section>

        {/* Мобильные приложения */}
        <section style={{ background: '#F9FAFB' }}>
          <div className="container">
            <div className="smart-block fade-up" style={{ background: 'white', display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '2rem' }}>
              <div style={{ flex: 1 }}><div className="screenshot-placeholder"><img src="https://placehold.co/450x280/F9FAFB/32bea6?text=Мобильное+приложение" alt="Мобильное приложение" /><div className="mockup-label">📱 Управляйте прокатом со смартфона</div></div></div>
              <div style={{ flex: '1.2' }}>
                <i className="fas fa-mobile-alt" style={{ fontSize: '2.5rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                <h3 style={{ fontSize: '1.8rem', fontWeight: '700' }}>Мобильные приложения для всех</h3>
                <p>Сотрудники и клиенты могут пользоваться сервисом через нативные приложения для iOS и Android.</p>
                <ul style={{ listStyle: 'none', marginTop: '1rem' }}>
                  <li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> <strong>Для бизнеса:</strong> приём заказов, управление парком, уведомления</li>
                  <li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> <strong>Для клиентов:</strong> выбор по фото, бронирование, отслеживание возврата</li>
                </ul>
                <div className="app-badges" style={{ display: 'flex', justifyContent: 'flex-start', gap: '20px', margin: '20px 0 0 0' }}>
                  <a href="https://apps.apple.com/ru/app/id6773870898" target="_blank"><img src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" alt="App Store" style={{ height: '45px' }} /></a>
                  <a href="https://play.google.com/store/apps/details?id=com.planna.app" target="_blank"><img src="https://play.google.com/intl/en_us/badges/static/images/badges/ru_badge_web_generic.png" alt="Google Play" style={{ height: '45px' }} /></a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="container fade-up" style={{ textAlign: 'center' }}>
            <h2 className="section-title">Как это работает за 5 минут</h2>
            <OnboardingSteps
              isRegistered={this.state.isAuthenticated}
              hasCompany={this.state.companies.length > 0}
              hasServices={this.state.services.length > 0}
              hasResources={this.state.resources.length > 0}
              servicesCount={this.state.services.length}
              resourcesCount={this.state.resources.length}
              companyId={this.state.services.length > 0 ? this.state.companies[0].id : 0}
            />
          </div>
        </section>

        {/* FAQ */}
        <section>
          <div className="container fade-up">
            <h2 className="section-title" style={{ textAlign: 'center' }}>Частые вопросы</h2>
            <div style={{ maxWidth: '800px', margin: '2rem auto' }}>
              {faqs.map((faq, idx) => (
                <div key={idx} className={`faq-item ${this.state.activeFaq === idx ? 'active' : ''}`}>
                  <div className="faq-question" onClick={() => this.toggleFaq(idx)}>{faq.q} <i className="fas fa-chevron-down"></i></div>
                  <div className="faq-answer">{faq.a}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section style={{ background: 'linear-gradient(115deg, #1F2937 0%, #32bea6 100%)', color: 'white' }}>
          <div className="container fade-up" style={{ textAlign: 'center', padding: '80px 0' }}>
            <h2 style={{ fontSize: '2.2rem', fontWeight: '800' }}>Начните управлять прокатом уже сегодня</h2>
            <p style={{ fontSize: '1.1rem', margin: '1rem auto 2rem', maxWidth: '600px', opacity: 0.9 }}>Больше никаких бумажных журналов и потерянного оборудования. Ваш парк будет работать эффективно.</p>
            <a href="/configcompany" className="btn-filled" style={{ background: 'white', color: '#1F2937', boxShadow: 'none' }}>Подключить прокат бесплатно <i className="fas fa-arrow-right"></i></a>
            <p style={{ marginTop: '2rem', fontSize: '0.9rem' }}>Настройка за 15 минут. QR-код, напоминания, аналитика — 0₽</p>
          </div>
        </section>

        {/*
        <h2 class="main2">Как это работает за 5 минут</h2>
        <p class="main3">
          <div class="nowrap">{this.state.isAuthenticated ? <><span class="btndone">Зарегистрироваться</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="authentication/register">Зарегистрироваться</a>}<div class="arrowright"></div></div>
          <div class="nowrap">{this.state.companies.length > 0 ? <><span class="btndone">Зарегистрировать бизнес бесплатно</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="configcompany">Зарегистрировать бизнес бесплатно</a>}<div class="arrowright"></div></div>
          <div class="nowrap">{this.state.companies.length > 0 ? <><span class="btndone">Добавить услуги</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="configservices">Добавить услуги</a>}<div class="arrowright"></div></div>
          <div class="nowrap">{this.state.companies.length > 0 ? <><span class="btndone">Добавить русурсы</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="configresources">Добавить русурсы (объекты аренды)</a>}<div class="arrowright"></div></div>
          <div class="nowrap"><a style={{marginLeft: "5px"}} class="btn btn-primary" href="configqrcode">Распечатать QR-код со ссылкой для клиентов</a><div class="arrowright"></div></div>
          <a style={{marginLeft: "5px"}} class="btn btn-primary" href={this.state.companies.length > 0 ? `booking/${this.state.companies[0].id}` : "booking"}>Начать записывать клиентов</a>
        </p>
        */}
      </div>
    );
  }
}
